import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { Status } from '../../classes/status.class';
import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class StatusService {
    private urlPrefix = 'status';

    constructor(private apiService: ApiService) {}

    public getList(type: string) {
        return this.apiService.getCallData$<Status[]>(this.urlPrefix).pipe(
            map(statusList => statusList.filter(status => status.type === type)),
            shareReplay(1)
        );
    }
}
